/**
 * Read More / Read Less for product short description (metafield HTML).
 * Re-initializes after variant change (innerHTML of #desc-* is replaced by product-info.js).
 */
(function () {
  const ROOT = '[data-short-desc-root]';

  function needsReadMore(root) {
    const inner = root.querySelector('[data-short-desc-inner]');
    if (!inner || !inner.innerHTML.trim()) return false;

    const kids = inner.children;
    if (kids.length > 1) return true;

    if (kids.length === 1) {
      return kids[0].scrollHeight > kids[0].clientHeight + 1;
    }

    return inner.innerHTML.trim() !== '' && inner.scrollHeight > inner.clientHeight + 1;
  }

  function refreshRoot(root) {
    const toggle = root.querySelector('[data-short-desc-toggle]');
    const readMore = toggle?.dataset.readMoreText || 'Read More';
    if (!toggle) return;

    root.classList.remove('short_desc--expanded');
    toggle.setAttribute('aria-expanded', 'false');
    toggle.textContent = readMore;
    toggle.hidden = true;

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        const inner = root.querySelector('[data-short-desc-inner]');
        if (!inner || !inner.innerHTML.trim()) {
          toggle.hidden = true;
          return;
        }
        const show = needsReadMore(root);
        toggle.hidden = !show;
      });
    });
  }

  function refreshAll() {
    document.querySelectorAll(ROOT).forEach(refreshRoot);
  }

  document.addEventListener('click', (event) => {
    const toggle = event.target.closest('[data-short-desc-toggle]');
    if (!toggle || toggle.hidden) return;

    const root = toggle.closest('[data-short-desc-root]');
    if (!root) return;

    event.preventDefault();
    const readMore = toggle.dataset.readMoreText || 'Read More';
    const readLess = toggle.dataset.readLessText || 'Read Less';
    const expanded = root.classList.toggle('short_desc--expanded');

    toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    toggle.textContent = expanded ? readLess : readMore;
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refreshAll);
  } else {
    refreshAll();
  }

  if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, () => {
      setTimeout(refreshAll, 0);
    });
  }
})();
